import { Anchor, Group, Stack, Text, Title } from "@mantine/core";
import { Link, Outlet } from "@tanstack/react-router";

/** The staff back office (A7): every action here is audited by the API. */
export function StaffLayout() {
  return (
    <Stack gap="md">
      <Stack gap={4}>
        <Title order={1}>Staff tools</Title>
        <Text size="sm" c="var(--cai-color-text-muted)">
          Every change here is written to the audit log with your name.
        </Text>
      </Stack>
      <Group component="nav" aria-label="Staff" gap="md">
        <Anchor
          renderRoot={(props) => <Link {...props} to="/staff" activeOptions={{ exact: true }} />}
        >
          Teams
        </Anchor>
        <Anchor renderRoot={(props) => <Link {...props} to="/staff/usage" />}>Usage</Anchor>
        <Anchor renderRoot={(props) => <Link {...props} to="/staff/ai-tasks" />}>AI tasks</Anchor>
        <Anchor renderRoot={(props) => <Link {...props} to="/staff/audit" />}>Audit log</Anchor>
      </Group>
      <Outlet />
    </Stack>
  );
}
